/**
 * `/serve` — public, plain-language guide for "build on my own computer" (Parity P0, Zuse Serve /
 * Herdr model): the owner's Claude or ChatGPT subscription does the work on their laptop; Bystep
 * stays the control surface. Landing-styled (`.mk`), no jargon outside the copyable commands.
 */
import { createFileRoute } from '@tanstack/react-router'
import { MkFooter, MkNav } from '#/components/landing/mk'
import { ServeGuide } from '#/components/serve/serve-guide'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/serve')({
  head: () => ({
    meta: [
      { title: m.serve_page_meta_title() },
      { name: 'description', content: m.serve_page_meta_desc() },
      { property: 'og:title', content: m.serve_page_meta_title() },
      { property: 'og:description', content: m.serve_page_meta_desc() },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: 'https://bystep.dev/brand/bystep-og.png' },
    ],
  }),
  component: ServePage,
})

function ServePage() {
  return (
    <div className="mk h-full overflow-y-auto overflow-x-hidden scroll-smooth">
      <MkNav />
      <ServeGuide />
      <MkFooter />
    </div>
  )
}
